<template>
  <div>
    <new-carousel />
  </div>
</template>

<script>
import NewCarousel from "@/views/static/CarouselTest.vue";

export default {
  components: {
    NewCarousel,
  },
}
</script>
